import React, { Component } from 'react';
import Iterator from '../core/Iterator';
import UrlHelper from '../core/UrlHelper';
import ParameterErrors from '../errors/ParameterErrors';
import ParameterValidation from '../validation/ParameterValidation';
import Scene360Hotspot from './Scene360Hotspot';
import Scene360Layer from './Scene360Layer';
const{throwNotProvided}=ParameterErrors;
export default class Scene360 {
	constructor(props){
		const {layers, hotspots, urlPrefix, uniqueId, levels, cameraEulerAngles} = props;
		if(urlPrefix===undefined||urlPrefix===null)
			throwNotProvided('urlPrefix');
		this.getLevels = this.getLevels.bind(this);
		this._urlPrefix= UrlHelper.makeSureSlashOnEnd(urlPrefix);
		ParameterValidation.validateArray(layers, 'layers', Scene360Layer);
		this._layers = layers;
		ParameterValidation.validateArray(hotspots, 'hotspots', Scene360Hotspot, true);
		this._hotspots = hotspots;
		if(uniqueId===undefined||uniqueId===null)
			throwNotProvided('uniqueId');
		this._uniqueId= uniqueId;
		this._levels= levels;
		this._cameraEulerAngles= cameraEulerAngles;
	}
	getLevels(){
        return this._levels;
	}
	get urlPrefix(){
		return this._urlPrefix;
	}
	get hotspots(){
		return this._hotspots;
	}
	get layers(){
		return this._layers;
	}
	get uniqueId(){
		return this._uniqueId;
	}
	get cameraEulerAngles(){
		return this._cameraEulerAngles;
	}
}
